import { SettlingGame } from '../models/settling-game'
import { gamePropsMapper } from './game-props.mapper'
import { GameDto } from '../dtos/game.dto'

export const settlingGameMapper = {
  mapToSettlingGame(settlingGameDto: GameDto): SettlingGame {
    return new SettlingGame({
      ...settlingGameDto,
      ...gamePropsMapper.mapToGameProps(settlingGameDto),
    })
  },
}
